import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';



class ApplicantData {
   
  PostPersonalData(ApplicantData){
                
        return axios.post(API_URL + `ApplicantData/PostPersonalData`,{
        
          
            ApplicantID :ApplicantData.ApplicantID ,
            SecondNameEN:ApplicantData.SecondNameEN ,
            ThirdNameEN: ApplicantData.ThirdNameEN ,
            FamilyNameEN :ApplicantData.FamilyNameEN,
            FirstNameAR :ApplicantData.FirstNameAR,
            SecondNameAR:ApplicantData.SecondNameAR ,
            ThirdNameAR :ApplicantData.ThirdNameAR , 
            FamilyNameAR:ApplicantData.FamilyNameAR , 
            LastNameAR:ApplicantData.LastNameAR , 
            ReligionID: ApplicantData.ReligionID,


        },{ headers: authHeader() })
     }
  PostApplicantEmailAndPhone(ContactInfo){
    return axios.post(API_URL + `ApplicantData/PostApplicantContactsInsert?ApplicantID=${ContactInfo.ApplicantID}&ContactTypeID=${ContactInfo.ContactTypeID}&ContactDetails=${ContactInfo.ContactDetails}&IsPrimary=${ContactInfo.IsPrimary}`,
        { headers: authHeader() } ) 
  }
  GetApplicantEmailAndPhone(ContactInfo){
    return axios.get(API_URL + `ApplicantData/GetListContactEmailsPhones?ContactTypeID=${ContactInfo.ContactTypeID}&ApplicantID=${ContactInfo.ApplicantID}`,
        { headers: authHeader() } ) 
  }
  GetAddressOfApplicants(ContactInfo){
    return axios.get(API_URL + `ApplicantData/GetAddressOfApplicants?ApplicantID=${ContactInfo}`,
    { headers: authHeader() } ) 
  }
  PostApplicantAddressInsert(ApplicantData){
    return axios.post(API_URL + `ApplicantData/PostApplicantAddressInsert?ApplicantID=${ApplicantData.ApplicantID}&CountryID=${ApplicantData.CountrySerial}&GovernorateID=${ApplicantData.GovernerateSerial}&Address=${ApplicantData.Address}`,
    { headers: authHeader() } )
  }

  PostEducationHistoryInsert(ApplicantData){
    return axios.post(API_URL + `ApplicantData/PostEducationHistoryInsert`,{
      ApplicantID :ApplicantData.ApplicantID ,
      CertificateTypeID:ApplicantData.CertificateTypeID,
      SpecializationTypeID:ApplicantData.SpecializationTypeID,
      Degree:ApplicantData.Degree,
      Percentage:ApplicantData.Percentage,
      YearID:ApplicantData.YearID 
    },
    { headers: authHeader() } )

    
  }
     
  GetCerificationData(ApplicantID){
    return axios.get(API_URL + `ApplicantData/GetCerificationData?ApplicantID=${ApplicantID}`,{
      
    },
    { headers: authHeader() } )
  }
 
  GetlistOfApplicantPreferences(ApplicantData){
    return axios.post(API_URL + `ApplicantData/GetlistOfApplicantPreferences?ApplicantID=${ApplicantData.UserIDSerial}&SemesterID=${ApplicantData.SEMESTERID}`,{
      
    },
    { headers: authHeader() } )
    }
  PostlistOfApplicantPreferences(ApplicantData){
    return axios.post(API_URL + `ApplicantData/PostInsertPreference?ApplicantID=${ApplicantData.ApplicantID}&FacultyBranchID=${ApplicantData.FacultyBranchID}&PreferenceID=${ApplicantData.PreferenceID}&applicantTypeID=${ApplicantData.EnrollmentTypeID}`,{
      
    },
    { headers: authHeader() } )
    }

    GetListofApplicantAttachments(ApplicantID){
      return axios.get(API_URL + `FileAttachments/FileAttachments_SelectByApplicantID?ApplicantID=${ApplicantID}&IsApplicant=${true}`,{
      
      },
      { headers: authHeader() } )
    }
    GetListofApplicantPayments(ApplicantID){
      return axios.get(API_URL + `Payments/GetApplicantPayments?ApplicantID=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }

    GetListOfCurrentAndHistoryActions(ApplicantID){
      return axios.get(API_URL + `Application/UpComingAction?ApplicantId=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetListOfHistoryActions(ApplicantID){
      return axios.get(API_URL + `Application/ApplicationHistory?ApplicantId=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetApplicantQualificationExams(ApplicantID){
      return axios.get(API_URL + `Exams/GetQualificationExams?ApplicantID=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetApplicantInbox(ApplicantID){
      return axios.post(API_URL + `Adm_InboxApi/PostInboxlstAPI`,{
        Serial : ApplicantID
      },
      { headers: authHeader() } )
    }
    GetAllApplicantDataList(ApplicantID){
      return axios.get(API_URL + `ApplicantData/GetAllApplicantDataList?ApplicantID=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    SetPrimary(ApplicantData){
      return axios.post(API_URL + `ApplicantData/PostChangeStatusIsPrimary?RowSerial=${ApplicantData.RowSerial}&FlagAddressContact=${ApplicantData.FlagContacttype}&IsPrimary=${ApplicantData.Primary}&ApplicantID=${ApplicantData.ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    ApplicantExam_UpdateExamType(ApplicantData){
      return axios.post(API_URL + `Exams/ApplicantExam_UpdateExamType?ExamTypeID=${ApplicantData.ExamTypeID}&ApplicantExamID=${ApplicantData.ApplicantExamID}&ApplicantID=${ApplicantData.ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    ApplicantExam_ChangeExamType(ApplicantData){
      return axios.post(API_URL + `Exams/ApplicantExam_ChangeExamType?ExamTypeID=${ApplicantData.ExamTypeID}&ApplicantExamID=${ApplicantData.ApplicantExamID}&ApplicantID=${ApplicantData.ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    PostApplicant_ExamDates_SelectUpComingExamDateByLocationAPI(ApplicantData){
      return axios.get(API_URL + `Exams/PostApplicant_ExamDates_SelectUpComingExamDateByLocationAPI?Location=${ApplicantData.ExamLocationsID}&ExamID=${ApplicantData.ExamID}&ApplicantExamID=${ApplicantData.ApplicantExamID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetApplicantExamTimes(ApplicantData){
      return axios.get(API_URL + `Exams/PostApplicant_ExamDates_SelectByExamDateAndLocationAPI?ExamDate=${ApplicantData.ExamDates}&ExamID=${ApplicantData.ExamID}&Location=${ApplicantData.ExamLocationsID}`,{
      
      },
      { headers: authHeader() } )
    }
    BookApplicantExam(ApplicantData){
      return axios.post(API_URL + `Exams/BookExamDate?ApplicantExamID=${ApplicantData.ApplicantExamID}&ExamDateID=${ApplicantData.ExamDateID}&ApplicantID=${ApplicantData.ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetExamNames(ApplicantID,SemesterID){
      return axios.get(API_URL + `Exams/GetExamNames?ApplicantID=${ApplicantID}&SemesterID=${SemesterID}`,{
      
      },
      { headers: authHeader() } )
    }
    BookExamAnotherTry(ApplicantID,RequiredExamID){
      return axios.post(API_URL + `Exams/InsertRequestedNewExamTry?ApplicantID=${ApplicantID}&RequiredExamID=${RequiredExamID}`,{
      
      },
      { headers: authHeader() } )
    }
    PostApplicantTerms(ApplicantData){
      return axios.post(API_URL + `TermsAndCondition/PostTermAcceptInsertUpdate?ApplicantSerial=${ApplicantData.ApplicantSerial}&termSerial=${ApplicantData.termSerial}&FlagTerm=${ApplicantData.FlagTerm}&isAgreed=${ApplicantData.isAgreed}`,{
      
      },
      { headers: authHeader() } )
    }
    PostCheckApplicantTermsAccept(ApplicantID){
      return axios.post(API_URL + `TermsAndCondition/LoadTermsCoditionsCheck?ApplicantSerial=${ApplicantID}`,{
      
      },
      { headers: authHeader() } )
    }
    GetApplicanrEmailByUserName(ApplicantCode){
      return axios.get(API_URL + `Security/EmailListByApplicantCode?ApplicantCode=${ApplicantCode}`,{
      
      },
      { headers: authHeader() } )
    }
    GetApplicanrEmailByNationalID(NationalID){
      return axios.get(API_URL + `Security/EmailListByNationalId?NationalId=${NationalID}`,{
      
      },
      { headers: authHeader() } )
    }
    SendForgetPasswordEmail(ApplicantId,ContactID){
      return axios.get(API_URL + `Security/SendPasswordToMail?ApplicantId=${ApplicantId}&ContactId=${ContactID}`,{
      
      },
      { headers: authHeader() } )
    }

    GetApplicantPaymentOrder(ApplicantId,SemeserID){
      
        return axios.get(API_URL + `Payments/GetOnlineReceipt?ApplicantID=${ApplicantId}&SemesterID=${SemeserID}`,{
        
        },
        { headers: authHeader() } )
  
    }
    ApplicantAttachmentDelete(ApplicantId , FileID){
      return axios.get(API_URL + `FileAttachments/FileAttachment_Delete?UserID=${ApplicantId}&FileSerial=${FileID}`,{

      },
      { headers: authHeader() } )
    }

    ApplicantPreferenceDelete(ApplicantId , ApplicationID){
      return axios.post(API_URL + `ApplicantData/ApplicantApplicationsDelete?ApplicantID=${ApplicantId}&serial=${ApplicationID}`,{

      },
      { headers: authHeader() } )
    }

    ApplicantUpdatePaymnet(ApplicantId ){
      return axios.post(API_URL + `CreateApplication/GetAllPaymentStatus?ApplicantID=${ApplicantId}`,{

      },
      { headers: authHeader() } )
    }
    GetApplicantApplicationHistory(ApplicantionId ){
      return axios.get(API_URL + `Application/ApplicationHistoryByApplicationID?ApplicationID=${ApplicantionId}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantRepeatedPaymnet(PaymentID ){
      return axios.post(API_URL + `CreateApplication/GetIfRepeated?PaymentID=${PaymentID}`,{

      },
      { headers: authHeader() } )
    }
    CancelinCampusExam(examSerial,ApplicantID ){
      return axios.post(API_URL + `Exams/CancelInCampusExam?ApplicantExamID=${examSerial}&ApplicantID=${ApplicantID}`,{

      },
      { headers: authHeader() } )
    }
    CheckApplicantIsStudent(ApplicantID ){
      return axios.post(API_URL + `ActiveDirectory/checkStudent?ApplicantId=${ApplicantID}`,{

      },
      { headers: authHeader() } )
    }
    ValidateADEmail(email ){
      return axios.post(API_URL + `ActiveDirectory/ValidateEmail?email=${email}`,{

      },
      { headers: authHeader() } )
    }
    CreateStudentEmail(data ){
      return axios.post(API_URL + `ActiveDirectory/CreateADAccount`,{
        Email: data.Email,
        StudentCode: data.StudentCode,
        FirstName: data.FirstName,
        LastName: data.LastName,
        Password: data.Password,
        SemesterID: 0,
        FacultyBranchID: data.FacultyBranchID,
        ApplicantID: data.ApplicantID
      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_MPGS(ApplicantID,PaymentList ){
      return axios.post(API_URL + `BankMasr_MPGS/Checkout_MPGS?ApplicantID=${ApplicantID}`,PaymentList,{

      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_MPGS_retriveOreder(ApplicantID,Order,resultIndicator,sessionversion ){
      return axios.post(API_URL + `BankMasr_MPGS/RetrieveOrder?ApplicantID=${ApplicantID}&SUOrderID=${Order}&resultIndicator=${resultIndicator}&sessionVersion=${sessionversion}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantMPGSRepeatedPaymnet(PaymentID ){
      return axios.post(API_URL + `BankMasr_MPGS/GetIfRepeated?PaymentID=${PaymentID}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_MPGSWalletRetrieveOrder(ApplicantId ){
      return axios.post(API_URL + `BankMasr_MPGS/WalletRetrieveOrder?ApplicantID=${ApplicantId}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantUPDRepeatedPaymnet(PaymentID ){
      return axios.post(API_URL + `BankMasr_UPG/GetIfRepeated?PaymentID=${PaymentID}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_UPG(ApplicantID,PaymentList ){
      return axios.post(API_URL + `BankMasr_UPG/BeforeCheckout_MPGS?ApplicantID=${ApplicantID}`,PaymentList,{

      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_UPGSWalletRetrieveOrder(ApplicantId ){
      return axios.post(API_URL + `BankMasr_UPG/UPG_CheckPaymentStatus?ApplicantID=${ApplicantId}`,{

      },
      { headers: authHeader() } )
    }
    ApplicantBankMasr_UPGScheckIfPaymentRepet(MerchantReference ){
      return axios.post(API_URL + `BankMasr_UPG/UPG_CheckIfFoundBefore?MerchantReference=${MerchantReference}`,{

      },
      { headers: authHeader() } )
    }
}

export default new ApplicantData();